import React from "react";

import { renderToStaticMarkup } from "react-dom/server";

import useDefaultMediaColor from "../../../hooks/useDefaultMediaColor";
import { getItemRendererStyle } from "../../../utils/fast";
import ContentTooltipItem from "../timeline/ContentTooltipItem";

import type { JSX } from "react";

import type {
  EPGTimelineItem,
  TimelineItemRendererProps,
} from "../timeline/timeline.types";

function EPGMediaItemRenderer({
  item,
  getItemProps,
  itemContext,
}: TimelineItemRendererProps<EPGTimelineItem>): JSX.Element {
  const { truncated } = itemContext.dimensions;
  const defaultMediaColor = useDefaultMediaColor();

  const itemProps = getItemProps({});

  const { ref, style, key } = itemProps;

  const { height: itemPropsHeight = 0 } = style;

  const styleItemCustom = getItemRendererStyle({
    color: defaultMediaColor,
    isVerticalTimeline: false,
    truncated,
  });

  const tooltipItem = (
    <ContentTooltipItem
      duration={item.duration}
      endTime={item.end_time}
      image={item.image}
      startTime={item.start_time}
      title={itemContext.title}
    />
  );

  return (
    <div
      key={key}
      ref={ref}
      data-tooltip-html={renderToStaticMarkup(tooltipItem)}
      data-tooltip-id="timeline-tooltip"
      data-tooltip-place="bottom"
      style={{
        ...style,
        ...styleItemCustom,
        height: itemPropsHeight,
        lineHeight: "unset",
      }}
    >
      <div className="flex size-full items-center justify-center">
        <span className="truncate p-[0.15625rem]">{itemContext.title}</span>
      </div>
    </div>
  );
}

export default EPGMediaItemRenderer;
